import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-assign-levels',
  templateUrl: './assign-levels.component.html',
  styleUrls: ['./assign-levels.component.scss']
})
export class AssignLevelsComponent implements OnInit {
  CourseList: any = [];
  filteredListCourse: any = [];
  AssLvlForm: FormGroup;
  dialogRef: MatDialogRef<any>;
  submitButton = true;
  AssignTable: [];
  New = true;
  editButton = false;
  deleteButton = false;
  Table = false;
  submitpayload: any;
  inputTimeout: any;
  collegeList: any = [];
  userCoData = []
  filteredCollegeList: any = [];
  LvlArray: FormArray;
  lvl = 0;
  sessionId = 0;
  CoCode = 0;
  filteredRoleList: any;
  RoleList: any;
  userList: any;
  filteredUserList: { [index: number]: any[] } = {};
  errMsg: any;
  sessionList: any;
  SessionFilterList: any;
  AssTable: any;
  AssLvl: FormArray;
  assignTableData: any[];
  arr: any;
  APIService: string;
  assinglevelCreate=true;
  userPermission: any;
  utp: string;
  UserCollege
  rowsCount: any;
  currentSearchQueries: string[] = [];
  constructor(public umsService: UmsService,private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService, private httpClient: HttpClient,
    public fb: FormBuilder) { this.APIService = environment.serviceUrl;}

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin'){
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
      if(element.PageName == 'Admission Approval Level' && element.PCreate == false)
      {
          this.assinglevelCreate = false;  
      }
      
    });
  }
    let id = ''
    this.sessionId = 0;
    this.lvl = 0;
    this.arr = [];
    this.CoCode = 0;
    this.submitButton = true;
    this.Table = false;
    this.editButton = false;
    this.deleteButton = false;
    this.AssLvlForm = this.fb.group({
      course: new FormControl('',[Validators.required]),
      college: new FormControl('',[Validators.required]),
      SessionId: new FormControl('',[Validators.required]),   
      LvlArray: new FormArray([]),    
    });
    // to fetch data for dropdowns below functions are called
    this.fetchRole();
    this.fetchUser();
    this.fetchSession(id)
  }

  getLvlArrayControls() {
    return (this.AssLvlForm.get('LvlArray') as FormArray).controls;
  }

  addNewRow2() {  //this function is called to add new row when clicked on add button
    const newRowIndex = this.rowsCount; // Or however you determine the new row index
  this.filteredUserList[newRowIndex] = this.userList.slice();
  this.rowsCount++;
    this.arr = this.AssLvlForm.controls.LvlArray.value
    this.LvlArray = this.AssLvlForm.get('LvlArray') as FormArray;
    if (this.LvlArray.invalid) {
      this.LvlArray.controls.forEach(element => {
        element.get('UserId').markAsTouched();
        element.get('Role').markAsTouched();
      })
    }
    else{
      this.lvl = this.AssLvlForm.controls.LvlArray.value.length
      const creds = this.AssLvlForm.controls.LvlArray as FormArray;
      creds.push(
        this.fb.group({
          Role: new FormControl ('',[Validators.required]),
          UserId:new FormControl ('',[Validators.required]),
          Intake: new FormControl(true),
          FinalApproval: new FormControl(false),
          AssignLevel: new FormControl(this.lvl + 1),
        })
      );
    }
  }

  Assign(id,i){ //this function is called to assign selected user user
    const payload = {};
    payload['UserId'] = id; 
    this.umsService.getUserRole(payload).subscribe(res => {
      if (res.status) {
        this.LvlArray = this.AssLvlForm.get('LvlArray') as FormArray;
        this.LvlArray.at(i).get('Role').setValue(res.data[0]['UserRole']);
      }
      else{
        this.LvlArray = this.AssLvlForm.get('LvlArray') as FormArray;
        this.LvlArray.at(i).get('Role').setValue('');
      }
    },(ERROR: HttpErrorResponse) => {
      this.LvlArray = this.AssLvlForm.get('LvlArray') as FormArray;
      this.LvlArray.at(i).get('Role').setValue('');
    })
  }

  UserData(user,i){ 
    //this function is called to check whether selected user is mapped in supervisor for course as if not mapped then it will create problem in further flow
    this.LvlArray = this.AssLvlForm.get('LvlArray') as FormArray;
    let isPopupShown = false;
    this.arr.forEach(element => {
      if(this.userCoData.find(item => item === user)){
      }
      else{
        if(!isPopupShown){
          let data = {};
          data['message'] = 'This user is not mapped to the given course';
          data['title'] = 'Alert';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.LvlArray = this.AssLvlForm.get('LvlArray') as FormArray;
          this.LvlArray.at(i).get('UserId').setValue('');
          isPopupShown = true;
        }
       
      }
      if(element.UserId == user){
        let data = {};
      data['message'] = 'User Already Assigned';
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.LvlArray = this.AssLvlForm.get('LvlArray') as FormArray;
      this.LvlArray.at(i).get('UserId').setValue('');
      }
      else{
        this.arr = this.AssLvlForm.controls.LvlArray.value
      }
    });
    
  }

  isOptionDisabled(loginId: string,i): boolean {
    this.arr = this.AssLvlForm.controls.LvlArray.value
    const selectedUserId = this.arr[i]['UserId'];
    return selectedUserId === loginId;
}
  
  addNewRow() {
    const newRowIndex = this.rowsCount; // Or however you determine the new row index
    this.filteredUserList[newRowIndex] = this.userList.slice();
    this.rowsCount++;
    this.lvl = this.AssLvlForm.controls.LvlArray.value.length
    const creds = this.AssLvlForm.controls.LvlArray as FormArray;
    creds.push(
      this.fb.group({
        Role: new FormControl ('',[Validators.required]),
        UserId:new FormControl ('',[Validators.required]),
        Intake: new FormControl(true),
        FinalApproval: new FormControl(false),
        AssignLevel: new FormControl(this.lvl + 1),
      })
    );
  }

  final(i,id){
    //this function is used to set the last row user as final approval level for scrutiny approval process
    this.lvl = this.AssLvlForm.controls.LvlArray.value.length
    const index = this.lvl - 1
    const data = this.AssLvlForm.controls.LvlArray.value
    data.forEach((element,i) => {
      this.AssLvl = this.AssLvlForm.get('LvlArray') as FormArray;
      this.AssLvl.at(i).get('FinalApproval').setValue(false);
      if(index == i){
        this.AssLvl.at(i).get('FinalApproval').setValue(true);
      }
    });
  }
  
  fetchSession(id) {
    this.spinner.show()
    const payload = {};
    payload['SnDefault'] = id;
    payload['SnNo'] = id; 
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        this.spinner.hide()
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  getCourse(id){
    this.spinner.show()
    this.Table = false;
    this.CourseList = [];
    this.filteredListCourse = [];
    this.collegeList = [];
    this.filteredCollegeList = [];
    this.sessionId = id
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    const payload = {};
    payload['CgCode'] = this.UserCollege;
    payload['SessionId'] = id; 
    this.umsService.fetchIntakeFilter(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
        this.AssLvlForm.controls['course'].setValue('');
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getClg(CoCode){
    this.spinner.show()
    this.Table = false;
    this.collegeList = [];
    this.filteredCollegeList = [];
    this.CoCode = CoCode;
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
      const payload = {};
      payload['CgCode'] = this.UserCollege
      this.umsService.getCollege(payload).subscribe((res) => {
        if(res.status){
          this.spinner.hide()
          this.collegeList = res.data;
          this.filteredCollegeList = this.collegeList.slice();
          this.AssLvlForm.controls['college'].setValue('');
        }
        else{
          this.spinner.hide()
          this.collegeList = []
          this.filteredCollegeList = []
        }
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide()
        this.collegeList = []
        this.filteredCollegeList = []
      })
    }
    else{
      this.UserCollege = ''
      const payload = {};
      // payload['SessionId'] = this.sessionId; 
    payload['CoCode'] = CoCode; 
    this.umsService.getCollegeCourse(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
        this.AssLvlForm.controls['college'].setValue('');
      }
      else{
        this.spinner.hide()
        this.collegeList = []
        this.filteredCollegeList = []
      }
     
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.collegeList = []
      this.filteredCollegeList = []
    })
    }
    
    
  }
  
  fetchRole() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'ROLE';
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.RoleList = res.data;
        this.filteredRoleList = this.RoleList.slice();
      } else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  getFilteredUserList(index: number): any[] {
    return this.filteredUserList[index] || this.userList;
  }

  updateFilteredUserList(filteredList: any[], index: number): void {
    if (this.isSearchQueryEmpty(index)) {
      // Restore the full list if the search query is cleared
      this.filteredUserList[index] = this.userList;
    } else {
      // Update the filtered list with current results, including empty list for invalid queries
      this.filteredUserList[index] = filteredList.length ? filteredList : [];
    }
  }

  isSearchQueryEmpty(index: number): boolean {
    // Logic to determine if the search query is empty
    const searchQuery = this.getSearchQuery(index);
    return searchQuery.trim() === '';
  }

  getSearchQuery(index: number): string {
    // Access the search query for the specific index (replace with your actual logic)
    return this.currentSearchQueries[index] || '';
  }

  updateSearchQuery(query: string, index: number): void {
    this.currentSearchQueries[index] = query;

    // Perform filtering based on the current query
    const filteredList = this.userList.filter(item => 
      item.LoginFullName.toLowerCase().includes(query.toLowerCase())
    );

    // Update the filtered list based on the current query
    this.updateFilteredUserList(filteredList, index);
  }

  fetchUser() {
    this.spinner.show();
    let payload = {};
    this.umsService.getUserList(payload).subscribe((res) => {
      this.spinner.hide();
      this.userList = [];
      if (res.status) {
        this.userList = res.data;
        this.filteredUserList = this.userList.slice();
        // Initialize filtered lists for each row, e.g., assuming there are 5 rows initially
        this.filteredUserList = {}; // Ensure it's reset
        for (let i = 0; i < this.rowsCount; i++) {
          this.filteredUserList[i] = this.userList.slice();
        }
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  getAssign(id){
    this.spinner.show();
    this.Table = false;
    const payload = {};
    payload['CoCode'] =  this.CoCode;
    if(id.CoCgCgCode == undefined){
      payload['CgCode'] =  id.CgCode;
    }
    else{
      payload['CgCode'] =  id.CoCgCgCode;
    }
    payload['SessionId'] =  this.sessionId;
    this.umsService.getAssLvl(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.Table = true;
        this.prepopulation(res.data)
      } else{
        this.spinner.hide()
        this.prepopulation(res.data)
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  prepopulation(id) {
    this.arr = id
    this.LvlArray = this.AssLvlForm.get('LvlArray') as FormArray;
      this.LvlArray.clear();
    this.assignTableData = [];
    if (id.length == 0) {
      this.Table = true;
      this.addNewRow();
      // this.LvlArray.clear();
    } else {
      this.LvlArray = this.AssLvlForm.get('LvlArray') as FormArray;
      this.LvlArray.clear();
      id.forEach((element,index) => {
        this.addNewRow();
      });
      this.LvlArray = this.AssLvlForm.get('LvlArray') as FormArray;
      this.assignTableData = Object.values(id);
      this.assignTableData.sort((a, b) => parseInt(a.AssignLevel) - parseInt(b.AssignLevel));
      this.assignTableData.forEach((element, i) => {
        this.LvlArray.at(i).get('Role').setValue(element.Role);
        this.LvlArray.at(i).get('UserId').setValue(element.UserId);
        this.LvlArray.at(i).get('Intake').setValue(element.Intake);
        this.LvlArray.at(i).get('AssignLevel').setValue(element.AssignLevel);
        this.LvlArray.at(i).get('FinalApproval').setValue(element.FinalApproval);
      });
      const data = this.AssLvlForm.controls.LvlArray.value
      data.forEach((element,index) => {
        if(element.Role == '' && element.UserId == ''){
          (<FormArray>this.AssLvlForm.get("LvlArray")).removeAt(index);
        }
      });
    } 
  }

  addnewrecord(e){
    if (e === 'true'){
      this.editButton = false;
      this.submitButton = true;
      this.deleteButton = false;
      this.ngOnInit();
      
    } 
    else {
      this.editButton = true;
      this.submitButton = false;
      this.deleteButton = true;
        this.ngOnInit();
    }
  }

  deleteRow(index){
    if(index !== 0){
      (<FormArray>this.AssLvlForm.get("LvlArray")).removeAt(index);
      this.arr = this.AssLvlForm.controls.LvlArray.value
      this.lvl = this.AssLvlForm.controls.LvlArray.value.length
      const index1 = this.lvl - 1
      const data = this.AssLvlForm.controls.LvlArray.value
      data.forEach((element,i) => {
        this.AssLvl = this.AssLvlForm.get('LvlArray') as FormArray;
        this.AssLvl.at(i).get('FinalApproval').setValue(false);
        if(index1 == i){
          this.AssLvl.at(i).get('FinalApproval').setValue(true);
        }
      });
      delete this.filteredUserList[index];
      this.rowsCount--;
    }
    else{
      let  data = {}
      data['message'] = "First Row Can Not Be Deleted"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    
    }
    
  }

  submit(){
    this.LvlArray = this.AssLvlForm.get('LvlArray') as FormArray;
    if (this.LvlArray.invalid) {
      this.LvlArray.controls.forEach(element => {
        element.get('UserId').markAsTouched();
        element.get('Role').markAsTouched();
      })
    }
    if (this.AssLvlForm.invalid) {
      this.AssLvlForm.get('course').markAsTouched();
      this.AssLvlForm.get('college').markAsTouched();
      this.AssLvlForm.get('SessionId').markAsTouched();
      return;
    } else {
       
      this.AddAssignLevel();
    }
  }

  deletedata(id) {
    this.spinner.show();
    
  }
  
  AddAssignLevel() {
    this.spinner.show();
    this.submitpayload = this.AssLvlForm.value;
    let abcd = this.AssLvlForm.get('LvlArray') as FormArray;
    let payload = abcd.value;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        CoCode: this.submitpayload.course,
        CgCode: this.submitpayload.college,
        SessionId: this.submitpayload.SessionId,
        Role: payload[0]['Role'],
        UserId: payload[0]['UserId'],
        AssignLevel: payload[0]['AssignLevel'],
        Intake: payload[0]['Intake'],
        FinalApproval: payload[0]['FinalApproval'],
      },
    };
    this.httpClient.delete(this.APIService + '/admin/AssignRole', options).subscribe((s) => {
        this.spinner.hide();
        // this.AddData();
        const cc = [];
        cc.push(s);
        if(cc[0]['status'] == true){
          this.AddData();
        }
        else if(cc[0]['status'] == false){
          const data = {};
          data['message'] = cc[0].message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent,data);
        }
       
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent,data);
      });
  }
  
  AddData(){
    this.submitpayload = this.AssLvlForm.value;
    let abcd = this.AssLvlForm.get('LvlArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array)=> {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            CoCode: new FormControl(this.submitpayload.course),
            CgCode: new FormControl(this.submitpayload.college),
            SessionId: new FormControl(this.submitpayload.SessionId),
            Role: new FormControl(element.Role),
            UserId: new FormControl(element.UserId),
            AssignLevel: new FormControl(element.AssignLevel),
            Intake: new FormControl(element.Intake),
            FinalApproval: new FormControl(element.FinalApproval)
          })
        )
       this.umsService.addAssLvl(arr1[0].value).subscribe(res => {
        if (res.status == false){
          iserror = true;
          this.errMsg = res.message
        } 
        if (index === array.length -1) resolve(); 
        else {
          iserror = false
          this.errMsg = res.message
        }
      }, (ERROR: HttpErrorResponse) => {
        iserror = true;
        this.errMsg = ERROR.error.message
        if (index === array.length -1) resolve();
       });
      });
    })
    bar.then(() => {
      if(iserror == false){
        let  data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }else{
        let  data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      }
    });
  }

  getUserCourse(code){
    this.spinner.show()
    let payload = {}
    this.userCoData = [];
    payload['SuCoCode'] = code;
    payload['SuOpid'] = '';
    this.umsService.getUserCourse(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide()
        res.data.forEach(element => {
          const isDuplicate = this.userCoData.some((item: any) => item === element.SuOpid);
              if (!isDuplicate) {
                this.userCoData.push(element.SuOpid);
              }
        });
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }
}
